import { Component } from "react";
import PropTypes from "prop-types";
import getOnChangeValue from "../../common/getOnChangeValue";
import { ServiceError, LoggedError } from "../../../../services/errors";
import addToBagEvent from "../../../../services/dataLayer/addToBagEvent";

const withUpdatePromise = WrappedComponent => {
  class WithUpdatePromise extends Component {
    constructor(props) {
      super(props);

      const { updateSavedItem, itemToBagIntent, itemToBag, itemToBagFailure } =
        props;

      this.updateSavedItem = updateSavedItem;
      this.itemToBagIntent = itemToBagIntent;
      this.itemToBag = itemToBag;
      this.itemToBagFailure = itemToBagFailure;
      this.updatePromise = Promise.resolve();
    }

    updateItem = itemToUpdate => {
      this.updatePromise = this.updateSavedItem(itemToUpdate)
        .catch(e => {
          if (e instanceof ServiceError) {
            return e;
          }

          this.updatePromise = Promise.resolve();
          throw new LoggedError(e, LoggedError.error);
        })
        .then(res => {
          const isCancelled = res === null;
          if (!isCancelled) {
            this.updatePromise = Promise.resolve();

            return res;
          }
        });

      return this.updatePromise;
    };

    updateItemColour = selectionEvent =>
      this.updateItem({
        ...this.props,
        selectedColourWayId: getOnChangeValue(selectionEvent)
      });

    updateItemVariant = selectionEvent =>
      this.updateItem({
        ...this.props,
        selectedVariantId: getOnChangeValue(selectionEvent)
      });

    handleItemToBagError = (id, e) => {
      if (e instanceof ServiceError) {
        return this.itemToBagFailure({ id, e });
      }
      throw new LoggedError(e, LoggedError.error);
    };

    itemToBagWaitingOnUpdate = async () => {
      const { id, variantId, seller, source, ...rest } = this.props;
      this.itemToBagIntent({ id, variantId, seller, source });

      try {
        const updateResult = await this.updatePromise;

        if (updateResult instanceof ServiceError) {
          throw updateResult;
        }
        addToBagEvent({
          variantId,
          seller,
          source,
          ...rest
        });
      } catch (e) {
        return this.handleItemToBagError(id, e);
      }

      return await this.itemToBag({ id, variantId, seller });
    };

    render = () => (
      <WrappedComponent
        {...this.props}
        updateItemColour={this.updateItemColour}
        updateItemVariant={this.updateItemVariant}
        itemToBag={this.itemToBagWaitingOnUpdate}
      />
    );
  }

  WithUpdatePromise.propTypes = {
    id: PropTypes.string.isRequired,
    variantId: PropTypes.number,
    seller: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    source: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    updateSavedItem: PropTypes.func.isRequired,
    itemToBagIntent: PropTypes.func.isRequired,
    itemToBag: PropTypes.func.isRequired,
    itemToBagFailure: PropTypes.func.isRequired
  };

  return WithUpdatePromise;
};

export default withUpdatePromise;
